/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */

import { getDefaultConfig } from '../../config/app-config';

export const companyTrackerLightRoutePath = getDefaultConfig().branding.ctlApp.supportedPaths;
const validRoots = [
  'company-tracker',
  ...companyTrackerLightRoutePath,
];

export const rootAppPath = `:rootAppPath(${validRoots.join('|')})`;
export const getRootAppPath = () => {
  const [, rootApp] = window.location.pathname.split('/');
  if (validRoots.includes(rootApp)) {
    return rootApp;
  }
  return validRoots[0];
}

export const isValidCompanyTrackerRoot = (rootAppPath: string) => validRoots.includes(rootAppPath);
